import { render, staticRenderFns } from "./app-auth.vue?vue&type=template&id=d9ce571e&scoped=true&"
import script from "./app-auth.vue?vue&type=script&lang=js&"
export * from "./app-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ce571e",
  null
  
)

export default component.exports